import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AssignmentDialogComponent} from './assignment-dialog/assignment-dialog.component';
import {AssignmentsComponent} from './assignments.component';
import {MaterialModule} from '../shared/material/material.module';
import {IwgcommonModule} from '../iwgcommon/iwgcommon.module';
import {FlexLayoutModule} from '@angular/flex-layout';
import {AssignmentService} from '../shared/services/assignment.service';
import {UserService} from '../shared/services/user.service';
import {AssignmentDetailComponent} from './assignment-detail/assignment-detail.component';
import {AssignmentTableComponent} from './assignment-table/assignment-table.component';
import { FormsModule } from '@angular/forms';
import { SharedPipesModule } from '../shared/pipes/sharedpipes.module';
import { TransferAssignmentComponent } from './transfer-assignment/transfer-assignment.component';
import { AssigmentdetailDocumentComponent } from './assigmentdetail-document/assigmentdetail-document.component';
import { AssigmentdocumentDialogComponent } from './assigmentdocument-dialog/assigmentdocument-dialog.component';
import { RouterModule, Routes } from '@angular/router';
import { CanDeactivateGuard } from '../shared/guard/can-deactivate.guard';
const routes: Routes = [{
    path:'',
    component:AssignmentsComponent
  },
  {
    path: ':assignmentId',
      component: AssignmentDetailComponent,
      canDeactivate: [CanDeactivateGuard]
  },
  {
    path: '',
    component:AssignmentsComponent,
    pathMatch: 'full'
  }
];

@NgModule({
    declarations: [AssignmentDialogComponent, AssignmentsComponent,
        AssignmentDetailComponent, 
        // AssignmentTableComponent,
        TransferAssignmentComponent, 
        AssigmentdetailDocumentComponent, AssigmentdocumentDialogComponent,
    ],
    imports: [
        CommonModule,
        MaterialModule,
        IwgcommonModule,
        FlexLayoutModule,
        FormsModule,
        SharedPipesModule,
        RouterModule.forChild(routes),
    ],
    providers: [AssignmentService, UserService],
    exports: [AssignmentDialogComponent, 
        AssignmentsComponent, AssignmentDetailComponent, 
        // AssignmentTableComponent, 
        TransferAssignmentComponent,AssigmentdocumentDialogComponent
    ]
})
export class AssignmentsModule {
}
